export const ROUTES = {
  SPLASH: '/',
  INDEX: '/index',
  LOGIN: '/login',
  REGISTER: '/register',
  PREFERENCE: '/preference',
  EDIT_PREFERENCE: '/edit-preference',
  HOMEPAGE: '/homepage',
  SETTINGS: '/settings',
  BOOKINGS: '/bookings',
  PAYMENTS: '/payments',
  CONFERENCE: '/conference',
  ACHIEVEMENT: '/achievement',
  DELETE_ACCOUNT: '/delete-account',
  DELETED_ACCOUNT: '/deleted-account',
  UPCOMING_DETAILS: '/upcoming-details',
  PAYMENT_HISTORY: '/payment-history',
  PAYMENT_HISTORY2: '/payment-history2',
  ASSESSMENT_DETAILS: '/assessment-details',
  SESSION: '/session',
  OTP: '/otp',
  DOC_SUMMARY: '/doc-summary',
} as const;
